const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
};

export const Services = (props) => {
  const numbers = ['01', '02', '03', '04', '05', '06'];

  return (
    <section id='services' style={{ padding: '100px 0', background: '#0a0a14' }}>

      {/* ── Section Header ── */}
      <div style={{ textAlign: 'center', marginBottom: '64px', padding: '0 24px' }}>
        <p style={{
          color: '#5ca9fb', fontWeight: '700',
          fontSize: '12px', letterSpacing: '3px',
          textTransform: 'uppercase', margin: '0 0 16px',
        }}>
          — What We Do
        </p>
        <h2 style={{
          fontFamily: 'Raleway, sans-serif',
          fontSize: 'clamp(32px, 4vw, 52px)',
          fontWeight: '800', color: '#fff',
          lineHeight: '1.1', margin: '0 0 20px',
        }}>
          Our <span style={{ color: '#5ca9fb' }}>Services</span>
        </h2>
        <p style={{
          color: 'rgba(255,255,255,0.45)',
          fontSize: '16px', maxWidth: '520px',
          margin: '0 auto', lineHeight: '1.75',
        }}>
          End-to-end HVAC solutions for commercial and industrial clients — from system design to ongoing maintenance.
        </p>
      </div>

      {/* ── Cards Grid ── */}
      <div className='container'>
        <div className='services-grid'>
          {props.data
            ? props.data.map((d, i) => {
                const isHighlight = d.name === 'Energy-Efficient AC Systems';
                return (
                  <div
                    key={`${d.name}-${i}`}
                    className='svc-card'
                    style={{
                      background: isHighlight
                        ? 'linear-gradient(135deg, #5ca9fb 0%, #6372ff 100%)'
                        : 'rgba(255,255,255,0.04)',
                      borderRadius: '20px',
                      padding: '36px 30px',
                      border: isHighlight ? 'none' : '1px solid rgba(255,255,255,0.07)',
                      position: 'relative',
                      overflow: 'hidden',
                      transition: 'transform 0.25s, box-shadow 0.25s',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-6px)';
                      e.currentTarget.style.boxShadow = isHighlight
                        ? '0 28px 64px rgba(92,169,251,0.45)'
                        : '0 20px 50px rgba(0,0,0,0.4)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    {/* Ghost number */}
                    <span style={{
                      position: 'absolute', top: '16px', right: '20px',
                      fontFamily: 'Raleway, sans-serif',
                      fontSize: '64px', fontWeight: '900', lineHeight: 1,
                      color: isHighlight ? 'rgba(255,255,255,0.18)' : 'rgba(255,255,255,0.04)',
                      userSelect: 'none', pointerEvents: 'none',
                    }}>
                      {numbers[i]}
                    </span>

                    {/* Icon box */}
                    <div className='svc-icon' style={{
                      width: '52px', height: '52px',
                      borderRadius: '14px',
                      background: isHighlight ? 'rgba(255,255,255,0.18)' : 'rgba(92,169,251,0.1)',
                      border: isHighlight ? '1px solid rgba(255,255,255,0.3)' : '1px solid rgba(92,169,251,0.25)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      marginBottom: '22px',
                      flexShrink: 0,
                    }}>
                      <i className={d.icon} style={{
                        fontSize: '20px',
                        color: isHighlight ? '#fff' : '#5ca9fb',
                      }}></i>
                    </div>

                    {/* Title */}
                    <h3 style={{
                      fontFamily: 'Raleway, sans-serif',
                      fontSize: '17px', fontWeight: '700',
                      color: '#fff',
                      margin: '0 0 12px',
                    }}>
                      {d.name}
                    </h3>

                    {/* Description */}
                    <p style={{
                      color: isHighlight ? 'rgba(255,255,255,0.82)' : 'rgba(255,255,255,0.42)',
                      fontSize: '14px', lineHeight: '1.78',
                      margin: '0 0 28px',
                      flex: 1,
                    }}>
                      {d.text}
                    </p>

                    {/* CTA link */}
                    <a
                      href='#contact'
                      onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
                      className='svc-cta'
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        color: isHighlight ? '#fff' : '#5ca9fb',
                        fontSize: '12px', fontWeight: '700',
                        textDecoration: 'none',
                        letterSpacing: '0.8px',
                        textTransform: 'uppercase',
                        marginTop: 'auto',
                      }}
                    >
                      Learn More
                      <i className='fa fa-arrow-right' style={{ fontSize: '11px' }}></i>
                    </a>
                  </div>
                );
              })
            : 'Loading...'}
        </div>

        {/* ── Bottom CTA strip ── */}
        <div style={{
          textAlign: 'center',
          marginTop: '64px',
          paddingTop: '56px',
          borderTop: '1px solid rgba(255,255,255,0.07)',
        }}>
          <p style={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: '16px', lineHeight: '1.7',
            marginBottom: '32px',
          }}>
            Need a tailored solution?&nbsp; <strong style={{ color: 'rgba(255,255,255,0.8)' }}>Speak to our engineers — no obligation.</strong>
          </p>
          <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href='tel:08103218560'
              className='svc-bottom-btn'
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: 'linear-gradient(to right, #5ca9fb, #6372ff)',
                color: '#fff', padding: '14px 32px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                boxShadow: '0 8px 24px rgba(92,169,251,0.4)',
              }}
            >
              <i className='fa fa-phone'></i> Call Now
            </a>
            <a
              href='https://wa.me/2348103218560?text=Hello%20Ac-Tech!%20I%E2%80%99d%20like%20to%20get%20a%20quote%20for%20AC%20service.%20Can%20you%20help%3F'
              target='_blank'
              rel='noopener noreferrer'
              className='svc-bottom-btn'
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                color: '#fff', padding: '14px 32px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                border: '2px solid rgba(255,255,255,0.2)',
              }}
            >
              <i className='fa fa-whatsapp'></i> Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>

      <style>{`
        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        /* Reset global #services i.fa blob styles */
        #services .svc-icon i.fa,
        #services .svc-cta i.fa,
        #services .svc-bottom-btn i.fa {
          font-size: inherit !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
          line-height: inherit !important;
        }

        #services .svc-icon i.fa {
          font-size: 20px !important;
        }

        @media (max-width: 960px) {
          .services-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 560px) {
          .services-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};
